import { useState } from 'react'
import { Link } from 'react-router-dom'
import { NavLink } from 'react-router-dom'
import { HashLink } from 'react-router-hash-link'
const Navigation = () => {
    const [navbarOpen, setNavbarOpen] = useState(false)

    return (
        <header className='items-center sticky top-0 z-10 block font-title lg:bg-white/20 lg:backdrop-blur-md '>
            <div className='max-w-[1200px] w-full mx-auto hidden lg:block relative'>
                <ul className='h-[70px] flex justify-around items-center cursor-pointer w-full align-middle navabar-text uppercase text-orange font-black text-shadow-black'>
                    <li className=''>
                        <HashLink to='/#top'>Top</HashLink>
                    </li>{' '}
                    <li className=''>
                        <HashLink to='/#booth'>Booth</HashLink>{' '}
                    </li>{' '}
                    <li className=''>
                        <HashLink to='/#panel'>Panel</HashLink>
                    </li>
                    <li>
                        <HashLink to='/#demos'>Demos</HashLink>{' '}
                    </li>{' '}
                    <li>
                        <HashLink to='/#activities'>Activities</HashLink>{' '}
                    </li>
                    <li className=''>
                        {' '}
                        <HashLink to='/#merch'>Merchandise</HashLink>{' '}
                    </li>{' '}
                </ul>
            </div>
            {/* mobile navbar */}
            <div className='cursor-pointer navbar'>
                <div className='flex flex-row lg:hidden px-8 sticky'>
                    <button className='delay-300 ease-in-out' onClick={() => setNavbarOpen(!navbarOpen)}>
                        {navbarOpen ? (
                            <svg
                                xmlns='http://www.w3.org/2000/svg'
                                className='h-12 w-12 absolute right-4 top-4 bg-navy rounded-lg'
                                fill='none'
                                viewBox='0 0 24 24'
                                stroke='white'
                            >
                                <path
                                    stroke-linecap='round'
                                    stroke-linejoin='round'
                                    stroke-width='2'
                                    d='M6 18L18 6M6 6l12 12'
                                />
                            </svg>
                        ) : (
                            <svg
                                xmlns='http://www.w3.org/2000/svg'
                                className='h-10 w-10 absolute right-4 top-4 bg-navy rounded-lg'
                                fill='none'
                                viewBox='0 0 24 24'
                                stroke='white'
                            >
                                <path
                                    strokeLinecap='round'
                                    strokeLinejoin='round'
                                    strokeWidth='2'
                                    d='M4 6h16M4 12h16M4 18h16'
                                />
                            </svg>
                        )}
                    </button>
                </div>
                {/* collapsable navbar */}
                <div
                    className={
                        'bg-navy lg:hidden font-black flex flex-col justify-center navabar-text' +
                        (navbarOpen ? ' block h-screen' : ' hidden')
                    }
                >
                    <ul className='flex-col space-y-8 uppercase'>
                        <li
                            onClick={() => {
                                setNavbarOpen(false)
                            }}
                            className=''
                        >
                            <HashLink to='/#top'>Top</HashLink>
                        </li>{' '}
                        <li
                            onClick={() => {
                                setNavbarOpen(false)
                            }}
                            className=''
                        >
                            <HashLink to='/#booth'>Booth</HashLink>{' '}
                        </li>{' '}
                        <li
                            onClick={() => {
                                setNavbarOpen(false)
                            }}
                            className=''
                        >
                            <HashLink to='/#panel'>Panel</HashLink>
                        </li>
                        <li
                            onClick={() => {
                                setNavbarOpen(false)
                            }}
                        >
                            <HashLink to='/#demos'>Demos</HashLink>{' '}
                        </li>{' '}
                        <li
                            onClick={() => {
                                setNavbarOpen(false)
                            }}
                        >
                            <HashLink to='/#activities'>Activities</HashLink>{' '}
                        </li>
                        <li
                            onClick={() => {
                                setNavbarOpen(false)
                            }}
                            className=''
                        >
                            <HashLink to='/#merch'>Merchandise</HashLink>{' '}
                        </li>{' '}
                    </ul>
                </div>
            </div>
        </header>
    )
}

export default Navigation
